import { CommonModule } from '@angular/common';
import { Component, AfterViewInit, OnDestroy, inject } from '@angular/core';
import { environment } from '@env/environment';
import { Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { CartApiService } from '@core/services-v2/cart/cart-api/cart-api.service';
import { CartStorageService } from '@core/services-v2/cart/cart-storage/cart-storage.service';
import { CartService } from '@core/services-v2/cart.service';
import { BlockUiService } from '@core/services-v2/block-ui/block-ui.service';
import { firstValueFrom } from 'rxjs';
import { PaymentDocumentType } from '@core/enums/payment-document-type.enum';
import { InvoiceForms } from '../components/invoice-form/models/invoice-forms.interface';
import { SessionService } from '@core/services-v2/session/session.service';
import { CheckoutStorageService } from 'src/app/checkout-v2/services/checkout-storage/checkout-storage.service';
import { UpdateCartCheckoutRequestDto } from '@core/services-v2/cart/cart-api/dtos/update-cart-checkout-request.dto';
import { GuestStorageService } from '@core/storage/guest-storage.service';
import { CreateGuestRequestDto } from '@core/services-v2/customer/dtos/guest/create-guest-request.dto';
import { IShoppingCart } from '@core/models-v2/cart/shopping-cart.interface';
import { ISession } from '@core/models-v2/auth/session.interface';
import { InvoiceFormComponent } from '../components/invoice-form/invoice-form.component';
import { InvoiceForm } from '../components/invoice-form/models/invoice-form.interface';
import { AddressDto } from '@core/services-v2/customer-address/dto/create-address.dto';

declare global {
  interface Window {
    paypal: any;
  }
}

@Component({
  selector: 'app-paypal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './paypal.component.html',
  styleUrls: ['./paypal.component.scss'],
})
export class PaypalComponent implements AfterViewInit, OnDestroy {
  private readonly paypalConfig = environment.paypal;

  //private readonly paymentBase = environment.apiEcommerce;
  private readonly paymentBase = `${environment.apiEcommerce}/api/v1/payment/paypal/`;
  //private readonly paymentBase = 'http://localhost:3500/api/v1/payment/paypal/';

  loading = false;
  paypalLoaded = false;
  paymentSuccessful = false;
  paymentError = '';

  @Input() paymentDocumentType: string = '';
  @Input() invoiceFormComponent: InvoiceFormComponent | null = null;
  @Input() orderAmount: number = 0;

  cartSession!: IShoppingCart;
  userSession!: ISession;

  private readonly sessionService = inject(SessionService);
  private readonly checkoutStorageService = inject(CheckoutStorageService);
  private readonly guestStorage = inject(GuestStorageService);

  constructor(
    private http: HttpClient,
    private router: Router,
    private cartApiService: CartApiService,
    private cartStorageService: CartStorageService,
    private cartService: CartService,
    private blockUiService: BlockUiService
  ) {}

  ngAfterViewInit(): void {
    this.initPayPal();
  }

  ngOnDestroy(): void {
    const paypalScript = document.getElementById('paypal-sdk');
    if (paypalScript) {
      document.body.removeChild(paypalScript);
    }
  }

  private initPayPal(): void {
    this.loading = true;

    const script = document.createElement('script');
    script.id = 'paypal-sdk';
    script.src = `https://www.paypal.com/sdk/js?client-id=${this.paypalConfig.clientId}&currency=${this.paypalConfig.currency}&locale=${this.paypalConfig.locale}`;

    script.onload = () => {
      this.loading = false;
      this.paypalLoaded = true;
      this.renderPayPalButtons();
      console.log('SDK de PayPal cargado correctamente');
    };

    script.onerror = (err) => {
      this.loading = false;
      this.paymentError = 'No se pudo cargar PayPal. Intente de nuevo.';
      console.error('Error al cargar SDK de PayPal:', err);
    };

    document.body.appendChild(script);
  }

  /*private renderPayPalButtons(): void {
    setTimeout(() => {
      const container = document.getElementById('paypal-button-container');
      if (!container) {
        console.error('paypal-button-container no encontrado en el DOM');
        this.paymentError = 'Error interno: Contenedor PayPal no disponible.';
        return;
      }

      if (typeof window['paypal'] !== 'undefined') {
        window['paypal']
          .Buttons({
            style: {
              layout: 'vertical',
              color: 'blue',
              shape: 'rect',
              label: 'checkout',
            },
            createOrder: async (_data: any, actions: any) => {
              return actions.order.create({
                purchase_units: [
                  {
                    amount: {
                      value: this.orderAmount.toFixed(2),
                      currency_code: this.paypalConfig.currency,
                    },
                    description: 'Compra en Implementos',
                    custom_id: 'ID-TRANSACCION-INTERNA-123',
                    reference_id: 'REF-123',
                  },
                ],
              });
            },
            onApprove: (_data: any, actions: any) => {
              return actions.order.capture().then(async (details: any) => {
                this.paymentSuccessful = true;

                const cart = this.cartStorageService.get();
                const cartId = cart?._id;
                const cartNumber = cart?.cartNumber;

                // Extraer datos de tarjeta (si disponibles)
                const cardData =
                  details?.purchase_units?.[0]?.payments?.captures?.[0]
                    ?.payment_source?.card;

                const tarjeta = cardData?.last_digits
                  ? `**** **** **** ${cardData.last_digits}`
                  : '****';

                const marca = cardData?.brand || 'PayPal';

                try {
                  this.blockUiService.set(true);

                  await firstValueFrom(
                    this.cartApiService.prepay({
                      cartId: cartId!,
                      invoiceType: PaymentDocumentType.RECEIPT,
                      documentId: cart?.guest?.documentId || cart?.customer?.documentId || '',
                    })
                  );

                  this.cartService.load();

                  const queryParams = {
                    status: 'approved',
                    paymentMethod: 'paypal',
                    shoppingCartId: cartId,
                    shoppingCartNumber: cartNumber,
                    currency: 'EUR',
                    transactionDate: new Date().toISOString(),
                    tarjeta: tarjeta,
                    marca_tarjeta: marca,
                  };

                  this.router.navigate(['/carro-compra/gracias-por-tu-compra'], {
                    queryParams: {
                      params: btoa(JSON.stringify(queryParams)),
                    },
                  });
                } catch (e) {
                  console.error('Error al finalizar el pago con PayPal', e);
                } finally {
                  this.blockUiService.set(false);
                }
              });
            },
            onError: (err: any) => {
              this.paymentError =
                'Ocurrió un error al procesar el pago. Por favor, intente de nuevo.';
              console.error('Error en PayPal:', err);
            },
          })
          .render('#paypal-button-container')
          .catch((err: any) => {
            console.error('Error al renderizar botones de PayPal:', err);
            this.paymentError =
              'No se pudieron cargar los botones de pago. Verifique su conexión.';
          });
      } else {
        this.paymentError = 'No se pudo cargar PayPal correctamente.';
        console.error('PayPal no está disponible');
      }
    }, 0);
  }*/

  /*private renderPayPalButtons(): void {
    setTimeout(() => {
      const container = document.getElementById('paypal-button-container');
      if (!container) {
        console.error('paypal-button-container no encontrado en el DOM');
        this.paymentError = 'Error interno: Contenedor PayPal no disponible.'; 
        return;
      }
      if (typeof window.paypal === 'undefined') {
        this.paymentError = 'PayPal no está disponible.';
        return;
      }

      window.paypal.Buttons({
        style: {
          layout: 'vertical',
          color: 'blue',
          shape: 'rect',
          label: 'checkout',
        },

        createOrder: async (_data: any, actions: any) => {
          try {
            // 1) Lee el carrito local
            const cart = this.cartStorageService.get();
            const shoppingCartId = cart?._id;
            if (!shoppingCartId) {
              throw new Error('No hay carrito definido');
            }

            // 2) Llamada a la Gateway en :8080 que redirige a tu microservicio de payment
            const endpoint = `${this.paymentBase}paypal-v1/create-transaction?shoppingCartId=${shoppingCartId}`;
            const res: any = await firstValueFrom(this.http.get(endpoint));
            const orderId = res.orderId;
            if (!orderId) {
              throw new Error('No se obtuvo orderId de PayPal');
            }
            // 3) Devolvemos el orderId al SDK de PayPal:
            return orderId;
          } catch (err) {
            console.error('Error al crear orden en backend:', err);
            this.paymentError =
              'Error al inicializar el pago. Intente nuevamente.';
            return actions.reject();
          }
        },

        onApprove: async (_data: any, actions: any) => {
          this.blockUiService.set(true);
          try {
            // 1) Capturamos la orden desde el cliente:
            const details: any = await actions.order.capture();
            this.paymentSuccessful = true;

            // 2) Extraemos datos de la captura
            const captureInfo =
              details.purchase_units?.[0]?.payments?.captures?.[0];
            const tarjeta = captureInfo?.payment_source?.card
              ? `**** **** **** ${captureInfo.payment_source.card.last_digits}`
              : 'PayPal balance';
            const marca = captureInfo?.payment_source?.card?.brand || 'PayPal';

            // 3) Notificamos a nuestro backend de confirmación (opcional):
            const orderId = _data.orderID || details.id;
            const payerId = details.payer.payer_id;
            const confirmEndpoint = `${this.paymentBase}paypal-v1/confirm-transaction?token=${orderId}&PayerID=${payerId}`;
            await firstValueFrom(this.http.get(confirmEndpoint));

            // 4) Ejecutamos lógica post-pago en frontend (prepay, vaciar carrito, etc.)
            await firstValueFrom(
              this.cartApiService.prepay({
                cartId: this.cartStorageService.get()?._id!,
                invoiceType: PaymentDocumentType.RECEIPT,
                documentId:
                  this.cartStorageService.get()?.guest?.documentId ||
                  this.cartStorageService.get()?.customer?.documentId ||
                  '',
              })
            );
            this.cartService.load();

            // 5) Redirigimos a la página de “Gracias” con parámetros
            const cart = this.cartStorageService.get();
            const cartId = cart?._id;
            const cartNumber = cart?.cartNumber;
            const queryParams = {
              status: 'approved',
              paymentMethod: 'paypal',
              shoppingCartId: cartId,
              shoppingCartNumber: cartNumber,
              currency: this.paypalConfig.currency,
              transactionDate: new Date().toISOString(),
              tarjeta,
              marca_tarjeta: marca,
            };
            this.router.navigate(['/carro-compra/gracias-por-tu-compra'], {
              queryParams: {
                params: btoa(JSON.stringify(queryParams)),
              },
            });
          } catch (err) {
            console.error('Error al capturar orden en frontend:', err);
            this.paymentError =
              'Ocurrió un error al procesar el pago. Intenta de nuevo.';
          } finally {
            this.blockUiService.set(false);
          }
        },

        onError: (err: any) => {
          console.error('Error en PayPal:', err);
          this.paymentError =
            'Ocurrió un error al procesar el pago. Por favor, intenta de nuevo.';
        },
      })
        .render('#paypal-button-container')
        .catch((err: any) => {
          console.error('Error al renderizar botones de PayPal:', err);
          this.paymentError =
            'No se pudieron cargar los botones de pago. Verifica tu conexión.';
        });
    }, 0);
  }*/

  private renderPayPalButtons(): void {
    setTimeout(() => {
      const container = document.getElementById('paypal-button-container');
      if (!container) {
        console.error('paypal-button-container no encontrado en el DOM');
        this.paymentError = 'Error interno: Contenedor PayPal no disponible.';
        return;
      }
      if (typeof window.paypal === 'undefined') {
        this.paymentError = 'PayPal no está disponible.';
        return;
      }

      window.paypal
        .Buttons({
          style: {
            layout: 'vertical',
            color: 'blue',
            shape: 'rect',
            label: 'checkout',
          },

          // 1) Pedimos al backend que cree la orden en PayPal y nos devuelva el orderId
          createOrder: async (_data: any) => {
            // new-prepay
            this.cartSession = this.cartStorageService.get()!;
            this.userSession = this.sessionService.getSession();
            const isValidInvoiceForm =
              this.paymentDocumentType !== 'invoice' ||
              this.invoiceFormComponent?.invoiceForm.valid;
            let invoiceFormData: InvoiceForms | null = null;
            if (this.paymentDocumentType === 'invoice') {
              try {
                invoiceFormData =
                  this.invoiceFormComponent?.submit(false) || null;
              } catch (e) {
                console.log(e);
                throw e;
              }
            }
            if (isValidInvoiceForm) {
              await this.updateCartBeforeCheckout(invoiceFormData);
            }

            const cart = this.cartStorageService.get();
            const shoppingCartId = cart?._id;
            if (!shoppingCartId) {
              console.error('No hay carrito definido');
              throw new Error('No hay carrito definido');
            }

            const endpoint = `${this.paymentBase}create-transaction?shoppingCartId=${shoppingCartId}`;
            const res: any = await firstValueFrom(this.http.get(endpoint));
            if (!res.orderId) {
              console.error('Backend no devolvió orderId');
              throw new Error('Backend no devolvió orderId');
            }
            return res.orderId;
          },

          // 2) Al aprobar, notificamos al backend para que capture la orden
          onApprove: async (data: any) => {
            this.blockUiService.set(true);
            try {
              // 1) Confirmar captura en tu back
              const orderId = data.orderID;
              const payerId = data.payerID;
              const confirmEndpoint = `${this.paymentBase}confirm-transaction?token=${orderId}&PayerID=${payerId}`;
              await firstValueFrom(this.http.get(confirmEndpoint));

              // 2) Marcar éxito en UI y navegar
              this.paymentSuccessful = true;
              const cart = this.cartStorageService.get()!;
              const queryParams = {
                status: 'approved',
                paymentMethod: 'paypal',
                shoppingCartId: cart._id,
                shoppingCartNumber: cart.cartNumber,
                currency: this.paypalConfig.currency,
                transactionDate: new Date().toISOString(),
              };
              this.router.navigate(['/carro-compra/gracias-por-tu-compra'], {
                queryParams: { params: btoa(JSON.stringify(queryParams)) },
              });
            } catch (err) {
              console.error('Error al confirmar orden en backend:', err);
              this.paymentError =
                'Ocurrió un error al procesar el pago. Por favor, intenta de nuevo.';
            } finally {
              this.blockUiService.set(false);
            }
          },

          onError: (err: any) => {
            console.error('Error en PayPal SDK:', err);
            this.paymentError =
              'Ocurrió un error al procesar el pago. Por favor, intenta de nuevo.';
          },
        })
        .render('#paypal-button-container')
        .catch((err: any) => {
          console.error('Error al renderizar botones de PayPal:', err);
          this.paymentError =
            'No se pudieron cargar los botones de pago. Verifica tu conexión.';
        });
    }, 100);
  }

  /**
   * Actualizar el carro de compras antes de realizar el pago.
   * - Actualiza el tipo de documento de pago (boleta, factura).
   * - Antes era prepay.
   * @returns
   */
  updateCartBeforeCheckout(invoiceParams: InvoiceForms | null): Promise<any> {
    const DEFAULT_PAYMENT_TYPE = this.sessionService.isEnterprise()
      ? PaymentDocumentType.INVOICE
      : PaymentDocumentType.RECEIPT;

    const paymentDocumentType =
      this.checkoutStorageService.getPaymentDocumentType() ||
      DEFAULT_PAYMENT_TYPE;

    const isReceipt = paymentDocumentType === PaymentDocumentType.RECEIPT;
    const isLoggedIn = this.sessionService.isLoggedIn();
    const isEnterprise = this.sessionService.isEnterprise();
    const updateCartRequest: UpdateCartCheckoutRequestDto = {
      cartId: this.cartSession._id!,
      invoiceType: paymentDocumentType,
      documentId: '',
    };
    //const address = this.checkoutStorageService.getDeliveryAddress();
    /*const isValidAddress: boolean =
      paymentDocumentType.toLowerCase() === PaymentDocumentType.INVOICE &&
      address != null;*/

    // Obtener documentId =========================================================
    const guest = this.guestStorage.get();
    //
    if (!isLoggedIn) {
      // Si no esta logueado
      if (!guest) {
        throw new Error('No se han ingresado los datos del invitado');
      }
      // Si es boleta
      if (isReceipt) {
        updateCartRequest.documentId = guest.documentId;
      } else {
        // Si es factura
        if (!invoiceParams) {
          throw new Error('No se han ingresado los datos de facturación');
        }
        const { business, invoiceAddress, isRegistered } = invoiceParams;

        if (!business) {
          throw new Error(
            'No se han ingresado los datos de la empresa para el proceso de facturación'
          );
        }
        if (!isRegistered) {
          updateCartRequest.business = { ...business, phone: guest.phone };
        }
        updateCartRequest.documentId = business.documentId;

        if (invoiceAddress) {
          updateCartRequest.invoiceAddress = invoiceAddress;
        }
      }
    } else if (isReceipt || isEnterprise) {
      // Si es Boleta o Empresa:
      updateCartRequest.documentId = this.userSession.documentId;
    } else {
      // Si es Factura y B2C:
      if (!invoiceParams) {
        throw new Error('No se han ingresado los datos de facturación');
      }
      const { business, invoiceAddress, invoiceAddressId, isRegistered } =
        invoiceParams;

      if (!business) {
        throw new Error(
          'No se han ingresado los datos de la empresa para el proceso de facturación'
        );
      }
      if (!isRegistered) {
        updateCartRequest.business = {
          ...business,
          phone: this.userSession.phone || '',
        };
      }

      updateCartRequest.documentId = business.documentId;
      updateCartRequest.ecommerceDocumentId = this.userSession.documentId;
      if (invoiceAddress) {
        updateCartRequest.invoiceAddress = invoiceAddress;
      } else if (invoiceAddressId) {
        updateCartRequest.invoiceAddressId = invoiceAddressId;
      }
    }

    if (!isLoggedIn && guest) {
      const formmatedPhone = `${environment.phone.code}${guest.phone}`;
      const guestAddress = this.checkoutStorageService.getDeliveryAddress();

      const createGuestRequest: CreateGuestRequestDto = {
        email: guest.email ?? '',
        documentId: guest.documentId ?? '',
        firstName: guest.firstName ?? '',
        lastName: guest.lastName ?? '',
        phone: formmatedPhone,
      };
      const isDelivery =
        this.cartSession.shipment?.deliveryMode === 'delivery';
      if (isDelivery) {
        if (!guestAddress) {
          throw new Error('No se ha seleccionado una dirección de entrega');
        }
        console.log('createGuestRequest.address', guestAddress);
        createGuestRequest.address = {
          location: guestAddress.location?.toUpperCase() || '',
          city: guestAddress.city?.toUpperCase() || '',
          region: guestAddress.region?.toUpperCase() || '',
          province: guestAddress.province?.toUpperCase() || '',
          number: guestAddress.number,
          street: guestAddress.street,
          streetType: guestAddress.streetType || '',
          postalCode: guestAddress.postalCode || '',
          departmentOrHouse: guestAddress.departmentHouse,
          reference: guestAddress.reference,
          latitude: guestAddress.lat ? +guestAddress.lat : null,
          longitude: guestAddress.lng ? +guestAddress.lng : null,
        };
      }
      updateCartRequest.guest = createGuestRequest;
    }

    /*if (
      !this.isLoggedIn &&
      paymentDocumentType === PaymentDocumentType.INVOICE
    ) {
      const { business } = params;
      updateCartRequest.business = {
        documentId: business.documentId,
        businessName: '',
        businessLineName: '',
        businessLineCode: '',
        email: '',
        phone: '',
      };
    }*/
    return firstValueFrom(this.cartApiService.prepay(updateCartRequest));
  }
}
